import React from 'react'
import { queries } from '../graphql'
import { useContext } from './Context'
import { routesDef } from '../../../../config/routes'
import { useConfirmDialog, useHistory, useMutation } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'
import { truncate } from '@ztechapps/common.utils'

export const DeleteBoardButton = () => {
  const { document } = useContext()
  const { confirm } = useConfirmDialog({ title: `'${truncate(document?.name, 50)}' will be removed.` })
  const [deleteBoard] = useMutation({ ...queries.deleteConfig })
  const history = useHistory()

  const onClick = async () => {
    await confirm(async () => {
      const input = {
        _id: document?._id,
      }
      await deleteBoard({ input })

      //navigate back to the list
      history.push(routesDef.AccountBoardsPage.altPath())
    })
  }

  return <BusyButton bsSize="sm" onClick={onClick} text="Delete" icon="trash" bsStyle="danger" />
}
